const exportFile = (data, fileName = 'data.json') => {
  const dataString = JSON.stringify(data, null, 4)
  const a = document.createElement("a")
  a.style.display = "none"
  document.body.appendChild(a)
  a.href = window.URL.createObjectURL(
    new Blob([dataString], { type: "text/plain" })
  )
  a.setAttribute("download", fileName)
  a.click()
  window.URL.revokeObjectURL(a.href)
  document.body.removeChild(a)
}

const importFile = () => new Promise((resolve, reject) => {
  const input = document.createElement("input")
  input.setAttribute('type', 'file')
  input.style.display = "none"
  input.addEventListener('change', (evt) => {
    const files = evt.target.files
    const file = files[0]
    const reader = new FileReader()
    reader.onload = (e) => {
      resolve(JSON.parse(e.target.result))
    }
    reader.onerror = reject
    reader.readAsText(file)  
  }, false)
  input.click()
})

export default {
  exportFile,
  importFile,
}